import { useApiAccountsV1UserRetrieve } from '../../client/api/api';
import { getCookie } from '../../getCookie';
import { getMinutesAsMilliseconds } from '../../utils/getMinutesAsMilliseconds';

const staleTime = getMinutesAsMilliseconds(60);

export const useCurrentUser = () => {
  const cookie = getCookie('csrftoken');
  return useApiAccountsV1UserRetrieve({
    query: {
      enabled: Boolean(cookie),
      staleTime,
    },
  });
};
